// extracted by mini-css-extract-plugin
module.exports = {"labelCard":"labelCard-module--labelCard--1V4xj","selected":"labelCard-module--selected--25mbW"};